import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { CustomFieldTemplateApi } from "go-segment/services/types";
import { partnerApi } from "../../../../../../../../../../services/Api/Partner/partnerApi";
import { api } from "../../../../../../../../../../services/Api/api";
import { OrganizationApi } from "../../../../../../../../../../services/Api/types";
import { selectPartner } from "../../../../../../../../../../services/partner/selectors";
import OrganizationForm from "../../../../../../../Admin/components/OrganizationAdminForm/OrganizationAdminForm";

interface MatchParams {
	organizationId: string;
}

const PartnerPreviewOrganizationsEditPage = () => {
	const [organization, setOrganization] = useState<OrganizationApi | undefined>();
	const [customFieldsConfig, setCustomFieldsConfig] = useState<CustomFieldTemplateApi[] | undefined>(undefined);
	const partner = useSelector(selectPartner);
	const { t } = useTranslation("admin");
	const { addFlash } = useFlash();
	const history = useHistory();
	const { organizationId } = useParams<MatchParams>();
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		fetchOrganization();
	}, []);

	const fetchOrganization = async () => {
		try {
			await fetchResourceConfig();
			const params = {
				include: "applications,applications.accesses,applications.properties,place,custom_fields",
			};
			const res = await partnerApi.getPartnerOrganization(Number(partner?.id), Number(organizationId), params);
			setOrganization(res);
			handleChangeTabTitle(
				`${res.name} | ${t("lib:common.word.locations")} | ${t("modules.partner.field.partner_panel.title")}`
			);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	const fetchResourceConfig = async () => {
		try {
			const params = {
				resource_name: "PARTNER_ORGANIZATION",
				custom_field_resource_type: "ORGANIZATION",
				custom_field_permission_scope: "WRITE",
			};
			const res = await api.getResourceConfig(params);
			setCustomFieldsConfig(res.custom_fields);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	const goBack = () => {
		history.push(`/partnership/${partner?.id}/organizations/${organization?.id}`);
	};

	if (!organization || !customFieldsConfig) {
		return <LoadingContainer />;
	}

	return (
		<>
			<Header back={goBack} title={`${t("modules.organization.header.edit.title")} ${organization.name}`} />
			<OrganizationForm
				isPartner
				partnerId={partner?.id}
				organization={organization}
				customFieldsConfig={customFieldsConfig}
			/>
		</>
	);
};

export default PartnerPreviewOrganizationsEditPage;
